<template>
    <div class="container h-100">
        <div class="col-md-6 p-0 h-100 m-auto">
            <a v-if="page == ''" @click="playAdQuiz();btnSfx();" class="bear-video animate__animated animate__slow animate__fadeIn">
                <video ref="bearVideoRef" :src="bearVideoUrl" type="video/mp4" muted autoplay loop playsinline>
                    Your browser does not support the video.
                </video>
                <div class="grass-left d-none d-md-block"></div>
                <div class="grass-right d-none d-md-block"></div>
            </a>
            <div v-if="page == ''" :class="'hive-tree animate__animated animate__fadeIn animate__delay-1s'+(honeyPercent == 0 ? ' empty' : '')">
                <div class="mobile-tree"></div>
                <div class="tree-giveaway" v-if="giveaway != null">
                    <span class="animate__animated animate__pulse animate__infinite"><i class="fas fa-times"></i> {{ giveaway.multiplier }}</span>
                    <div class="rotating-slow"></div>
                    <p v-if="bearType == 'no-videos'">{{ $t('home.giveaway_hive_info', { expiration: giveawayTimerText }) }}</p>
                </div>
                <div class="percent">
                    {{ honeyPercent > 0 ? honeyPercent+'%' : honeyResetDelay }}
                    <span v-if="honeyPercent == 0">{{ $t("home.hive_tree_empty") }}</span>
                </div>
                <div class="hive-holder">
                    <div class="hive">
                        <div class="hendle"></div>
                        <div class="honey" :style="'height:'+honeyPercent+'%;'"></div>
                        <div class="hole"></div>
                    </div>
                </div>
                <div class="rateLimit">
                    <span><i :style="'width:'+rateLimitPercent+'%;'" :class="rateLimitPercent > 66 ? 'green' : (rateLimitPercent > 33 ? 'orange' : 'red') "></i></span>
                    <div :class="rateLimitPercent <= 33 ? 'red' : ''"></div>
                </div>
            </div>

            <div v-if="page == ''" class="bottomActionHolder animate__animated animate__fadeInUp">
                <div v-if="bearType == 'play' && giveaway != null" class="text-center">
                    <b-button @click="playAdQuiz();btnSfx();" variant="giveaway" size="lg" class="mb-3" >{{ $t('home.btn_play') }}<span>{{ giveaway.multiplier }}</span></b-button>
                    <div v-html="$t('home.can_play_video_giveaway_description', { multiplier: giveaway.multiplier, expiration: giveawayTimerText })"></div>
                </div>
                <div v-else-if="bearType == 'play'" class="text-center">
                    <b-button @click="playAdQuiz();btnSfx();" variant="primary" size="lg" class="mb-3" >{{ $t('home.btn_play') }}</b-button>
                    <div>{{ $t("home.can_play_descriotion") }}</div>
                </div>
                <div v-else-if="bearType == 'no-videos'" class="text-center">
                    <h3>{{ $t('home.cant_play_title') }}</h3>
                    <div class="text-primary mb-2">{{ $t('home.cant_play_descriotion') }}</div>
                    <h4><b>{{ rateLimitTimerText }}</b></h4>
                </div>
            </div>

            <profiling v-if="page == 'profiling'" :options="profilingOptions" :adQuiz="adQuiz" @eventClose="closeAdQuiz" @eventNextVideo="playAdQuiz"/>
            <adquiz-question v-if="page == 'question'" :adQuiz="adQuiz" :retry="adQuizRetry" @eventClose="closeAdQuiz" @eventNextVideo="playAdQuiz" @eventNextProfiling="profiling" @eventUpdateUser="getUser" @eventRetry="retry" />
            <video-player v-if="page == 'video'" :adQuiz="adQuiz" @eventClose="closeAdQuiz" @eventEnded="page = 'question'" />
        </div>
        <adquiz-profit-popup ref="adQuizProfit" @nextStep="profitNextStep"></adquiz-profit-popup>
    </div>
</template>
<script>
import Vue from 'vue'
import Profiling from '../components/Profiling.vue';
import VideoPlayer from '../components/VideoPlayer.vue';
import AdQuizQuestion from '../components/AdQuizQuestion.vue';
import AdQuizProfitPopup from '../components/AdQuizProfitPopup.vue';
import api from '../api'

const AdQuizTab = Vue.component('adquiz-tab', {
    components: {
        VideoPlayer, AdQuizQuestion, Profiling, AdQuizProfitPopup
    },
    honeyTimer: null,
    rateLimitTimer: null,
    giveawayTimer: null,
    data(){
    	return {
            page: "",
            adQuiz: null,
            adQuizRetry: false,
            honeyPercent: 100,
            honeyResetDelay: "0s",
            rateLimitPercent: 0,
            rateLimitTimerText: "0s",
            giveawayTimerText: "",
            bearType: "play",
            bearVideoUrl: "",
            bearVideo: [
                { type: "play", url: "/video/default/bear-play.mp4" },
                { type: "no-videos", url: "/video/default/bear-no-videos.mp4" },
                { type: "play-mts", url: "/video/mts/bear-play.mp4" },
                { type: "no-videos-mts", url: "/video/mts/bear-no-videos.mp4" },
            ],
            profilingOptions:{
                adSurveyQuestionAvailable: false,
                userSegmentationQuestionAvailable: false,
            },
    	};
    },
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        closeAdQuiz(){
            this.adQuiz = null;
            this.page = '';
            this.getBudget();
        },

        profitNextStep(userProfit){
            let $this = this;
            // user profit from spinner
            this.adQuiz.userProfit = userProfit;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.adQuizQuestion(this.adQuiz.id)
                .then(res => {
                    $this.adQuiz.question = res.data;
                    if($this.adQuiz.videoUrl != undefined)
                        $this.page = "video";
                    else
                        $this.page = "question";
                            
                })
                .catch(err => {
                    $this.closeAdQuiz();
                    api.baseErrorHendler(err);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        setBear(type){
            for(let i in this.bearVideo){
                if(this.bearVideo[i].type == type + (this.user.mtsCustomer ? '-mts' : '')){
                    this.bearVideoUrl = this.bearVideo[i].url;
                    this.bearType = type;
                    break;
                }
            }
        },

        retry(obj){
            if(this.adQuiz == null) return;
            
            this.adQuiz.userProfit = obj.answer.potentialProfit;
            this.adQuiz.question = obj.question;
            this.adQuizRetry = true;

            if(this.adQuiz.videoUrl != undefined)
                this.page = "video";
            else
                this.page = "question";
        },

        profiling(options){
            this.page = 'profiling';
            this.profilingOptions = options;
        },

        playAdQuiz(){
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");
            this.page = '';
            
            api.adQuiz()
                .then(function (response) {
                    $this.adQuizRetry = false;
                    $this.adQuiz = response.data;
                    if($this.adQuiz != null){
                        if ($this.config.adQuizWheelOfFortuneEnabled != undefined && $this.config.adQuizWheelOfFortuneEnabled){
                            // open price popup
                            $this.$refs.adQuizProfit.show();
                        }
                        else {
                            if($this.adQuiz.videoUrl != undefined)
                                $this.page = "video";
                            else
                                $this.page = "question";
                        }
                    }
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    $this.getBudget();
                    $this.page = "";
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        getBudget(){
            const $this = this;

            if(this.honeyTimer != null){
                clearInterval(this.honeyTimer);
                this.honeyTimer = null;
            }

            api.budget()
                .then(function (response) {
                    $this.honeyPercent = response.data.remainingPercentage;
                    if(response.data.resetDelay != undefined){
                        let endtime = moment.utc().add(moment.duration(response.data.resetDelay));
                        let startime = moment.utc();
                        $this.honeyResetDelay = $this.formatTime(endtime); 
                        $this.honeyTimer = setInterval(() => { 
                            if(!moment.utc().isAfter(endtime))
                                $this.honeyResetDelay = $this.formatTime(endtime);
                            else{
                                $this.getBudget(); 
                            } 
                        }, 1000);
                    }
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                });
        },

        formatTime(time){
            let t = moment.duration(moment.utc(time).diff(moment.utc()));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return t.hours() + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return t.minutes() + ":" + this.pad2(t.seconds())+"m";

            return t.seconds()+"s";
        },
        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },

        getUser(){
            this.$store.dispatch('auth/getMe');
        },

        setGiveawayTimer(){
            if(this.giveawayTimer != null){
                clearInterval(this.giveawayTimer);
                this.giveawayTimer = null;
            }
            if(this.giveaway != null){
                let endtime = moment.utc(this.giveaway.expirationDateTime);
                this.giveawayTimerText = this.formatTime(endtime); 
                this.giveawayTimer = setInterval(() => { 
                    if(!moment.utc().isAfter(endtime))
                        this.giveawayTimerText = this.formatTime(endtime);
                }, 1000);
            }
        },

        userUpdated(){
            // rate limit
            let rateLimit = this.user.adQuizParticipationReportResponse.incorrectAnswerRateLimit != undefined && this.user.adQuizParticipationReportResponse.incorrectAnswerRateLimit.count == this.user.adQuizParticipationReportResponse.incorrectAnswerRateLimit.limit ? this.user.adQuizParticipationReportResponse.incorrectAnswerRateLimit : this.user.adQuizParticipationReportResponse.correctAnswerRateLimit;
            this.setBear(rateLimit.count < rateLimit.limit ? "play" : "no-videos");
            this.rateLimitPercent = (1 - (rateLimit.count / rateLimit.limit)) * 100;

            if(this.rateLimitTimer != null){
                clearInterval(this.rateLimitTimer);
                this.rateLimitTimer = null;
            }

            if(rateLimit.timeout != undefined){
                let endtime = moment.utc().add(moment.duration(rateLimit.timeout));
                let startime = moment.utc();
                this.rateLimitTimerText = this.formatTime(endtime); 
                this.rateLimitTimer = setInterval(() => { 
                    if(!moment.utc().isAfter(endtime))
                        this.rateLimitTimerText = this.formatTime(endtime);
                    else{
                        this.getUser(); 
                    } 
                }, 1000);
            }
        }
    },

    created(){
        this.bearVideoUrl = this.bearVideo[0].url;
        this.bearType = this.bearVideo[0].type;
        this.userUpdated();
    },

    mounted () {
        this.getBudget();
        this.$store.dispatch('sound/bg','BG_Home');
        this.setGiveawayTimer();
    },

    computed: {
        giveaway(){
            return this.$store.state.giveaway.data;
        },
        config(){
            return this.$store.state.config.data;
        },
        user() {
            return this.$store.state.auth.user;
        },
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        if(this.honeyTimer != null){
            clearInterval(this.honeyTimer);
        }
        if(this.rateLimitTimer != null){
            clearInterval(this.rateLimitTimer);
            this.rateLimitTimer = null;
        }
        if(this.giveawayTimer != null){
            clearInterval(this.giveawayTimer);
            this.giveawayTimer = null;
        }
    },

    watch:{
        user(){
            this.userUpdated();
        },

        page(){
            if(this.page != '') this.$emit("hideBottomNav", true);
            else this.$emit("hideBottomNav", false);
        },

        giveaway(){
            this.setGiveawayTimer();
        }
    }
});

export default AdQuizTab
</script>
